<igx-card class="card" elevated>
    <igx-card-header>
        <div igxCardThumbnail>
            <igx-avatar *ngIf="userService.$avatarUrl" [src]="(this.userService.$avatarUrl | async)!"></igx-avatar>
            <igx-avatar *ngIf="(userService.$avatarUrl | async) == null" [initials]="this.userService.initials ?? ''">
            </igx-avatar>
        </div>
        <h3 igxCardHeaderTitle>
            {{this.currentUser?.firstName ?? ""}} {{this.currentUser?.lastName ?? ""}}
        </h3>
        <h5 igxCardHeaderSubtitle>
            {{this.currentUser?.email ?? ""}}
        </h5>
    </igx-card-header>
    <igx-card-actions>
        <ng-container igxStart>
            <button [disabled]="this.currentUser == null" igxButton="contained" type="button"
                (click)="updateProfile(updateDialog)">
                Обнови профила
            </button>
            <button [disabled]="this.currentUser == null" igxButton="contained" type="button"
                (click)="addAvatar(avatarDialog)">
                Добави снимка
            </button>
            <button [disabled]="this.currentUser == null" igxButton="contained" type="button"
                (click)="updatePassword(passwordDialog)">
                Обнови парола
            </button>
        </ng-container>
    </igx-card-actions>
</igx-card>

<igx-dialog #updateDialog>
    <div class="dialog">
        <form [formGroup]="user" (ngSubmit)="onProfileSubmit(updateDialog)">
            <div class="column">
                <igx-input-group type="border">
                    <input igxInput [igxTextSelection]="true" name="firstName" type="text" formControlName="firstName">
                    <label igxLabel for="firstName">Име</label>
                    <igx-hint>Въведете вашето име</igx-hint>
                </igx-input-group>
                <igx-input-group type="border">
                    <input igxInput [igxTextSelection]="true" name="lastName" type="text" formControlName="lastName">
                    <label igxLabel for="lastName">Фамилия</label>
                    <igx-hint>Въведете вашата фамилия</igx-hint>
                </igx-input-group>
                <igx-input-group type="border">
                    <input igxInput [igxTextSelection]="true" name="email" type="email" formControlName="email">
                    <label igxLabel for="email">e-mail</label>
                    <igx-hint>Въведете вашият e-mail адрес</igx-hint>
                </igx-input-group>
            </div>
            <div class="actions">
                <button igxButton type="button" igxRipple (click)="cancel('update', updateDialog)">Откажи</button>
                <button igxButton="contained" type="submit" igxRipple [disabled]="!user.valid">Обнови профила</button>
            </div>
        </form>
    </div>
</igx-dialog>

<igx-dialog #avatarDialog>
    <form [formGroup]="file" (ngSubmit)="onAvatarSubmit(avatarDialog)">
        <div class="row">
            <igx-input-group type="border" style="flex-grow: 1;">
                <input igxInput [igxTextSelection]="true" name="avatar" type="file" formControlName="avatar"
                    (change)="loadAvatar($event)">
                <label igxLabel for="avatar">Профилна снимка</label>
                <igx-hint>Изберете файл за вашата профилна снимка</igx-hint>
            </igx-input-group>
            <img #avatarElement *ngIf="avatar" class="avatar">
        </div>
        <div class="actions">
            <button igxButton type="button" igxRipple (click)="cancel('avatar', avatarDialog)">Откажи</button>
            <button igxButton="contained" type="submit" igxRipple [disabled]="!file.valid">Добави снимка</button>
        </div>
    </form>
</igx-dialog>

<igx-dialog #passwordDialog>
    <div class="dialog">
        <form [formGroup]="password" (ngSubmit)="onPasswordSubmit(passwordDialog)">
            <div class="column">
                <igx-input-group type="border">
                    <input igxInput [igxTextSelection]="true" name="password" type="password"
                        formControlName="password">
                    <label igxLabel for="password">Парола</label>
                </igx-input-group>
                <igx-input-group type="border">
                    <input igxInput [igxTextSelection]="true" name="new_password" type="password"
                        formControlName="new_password">
                    <label igxLabel for="new_password">Нова парола</label>
                </igx-input-group>
                <igx-input-group type="border">
                    <input igxInput [igxTextSelection]="true" name="confirm_new_password" type="password"
                        formControlName="confirm_new_password">
                    <label igxLabel for="confirm_new_password">Потвърди новата парола</label>
                    <igx-hint *ngIf="passwordConfirming(password)">Въведете същата парола</igx-hint>
                </igx-input-group>
            </div>
            <div class="actions">
                <button igxButton type="button" igxRipple (click)="cancel('update', passwordDialog)">Откажи</button>
                <button igxButton="contained" type="submit" igxRipple [disabled]="!password.valid">Обнови парола</button>
            </div>
        </form>
    </div>
</igx-dialog>
